import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '@angular/cdk/layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PlatformModule } from '@angular/cdk/platform';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    LayoutModule,
    DragDropModule,
    PlatformModule
  ],
  exports: [
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    HttpClientModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    DragDropModule
  ]
})

/**
 * A module importing and exporting common Angular modules
 */
export class AngularModule {}
